import React, { useMemo } from 'react';
import styles from './index.less';
import classnames from 'classnames';

import { IMenuData, ActiveMenuType } from '@/interface/index';
import { TLang } from '@/utils/lang';
interface IFilterBar {
  leftObj: IMenuData | undefined;
  rightObj: IMenuData | undefined;
  barClick: (x: ActiveMenuType) => void;
  active?: ActiveMenuType;
  children?: React.ReactNode;
  history?: any;
  dispatch?: any;
}
const FilterBar = (props: IFilterBar): JSX.Element => {
  const { leftObj, rightObj, barClick, active } = props;
  const barClickHandle = (menuType, type) => {
    if (active === ActiveMenuType.left && type === 1) {
      barClick(ActiveMenuType.none);
    } else if (active === ActiveMenuType.right && type === 2) {
      barClick(ActiveMenuType.none);
    } else {
      barClick(menuType);
    }
  };

  const leftActiveColor = useMemo(() => {
    // if(ActiveMenuType.none === active || typeof active === 'undefined'){
    if (typeof leftObj?.districtId === 'number' && leftObj?.districtId !== 0) {
      return true;
    }
    return false;
    // }
    // return false
  }, [active, leftObj]);
  const rightActiveColor = useMemo(() => {
    // if(ActiveMenuType.none === active || typeof active === 'undefined'){
    if (rightObj?.value !== 1) {
      return true;
    }
    return false;
    // }
    // return false
  }, [active, rightObj]);
  return (
    <div className={styles.barWrapper}>
      <div
        className={`${styles.menu} ${leftActiveColor ? styles.activeColor : ''}`}
        onClick={() => barClickHandle(ActiveMenuType.left, 1)}
      >
        {leftObj && TLang(leftObj.label, 'home', false, false, null)}{' '}
        <i className={`${styles.iconArr} ${active === ActiveMenuType.left ? styles.active : ''}`} />{' '}
      </div>
      <div
        className={`${styles.menu} ${rightActiveColor ? styles.activeColor : ''}`}
        onClick={() => barClickHandle(ActiveMenuType.right, 2)}
      >
        {rightObj && TLang(rightObj.label, 'home', false, false, null)}{' '}
        <i
          className={`${styles.iconArr} ${active === ActiveMenuType.right ? styles.active : ''}`}
        />{' '}
      </div>
    </div>
  );
};
export default FilterBar;
